import { render } from "./Ligipaasetavus.vue?vue&type=template&id=6e622f67&ts=true"
import script from "./Ligipaasetavus.vue?vue&type=script&lang=ts"
export * from "./Ligipaasetavus.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__